import React, { useState } from "react";
import Load from "../../../common/Loader/Load";
import usePayment from "../hooks/usePayment";

const MakePayment = ({ form_pay }) => {
  const [loading, setLoading] = useState(false);
  const { urlPayu, idMercado } = usePayment(form_pay, setLoading);

  return (
    <div className="centrar">
      {loading && <Load />}
      {urlPayu && (
        <div className="centrar mt-5">
          <a
            href={urlPayu}
            target="_blank"
            rel="noopener noreferrer"
            className="m-2 btn-oferta"
          >
            Continuar con el pago
          </a>
        </div>
      )}
      {idMercado && (
        <div className="mt-5">
          {/* Contenedor para el botón de Mercado Pago */}
          <div className="cho-container" />
        </div>
      )}
    </div>
  );
};

export default MakePayment;
